import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';

const Footer = () => {
  const [showModal, setShowModal] = useState(false);

  // Parse localStorage safely
  let outletData = {};
  try {
    outletData = JSON.parse(localStorage.getItem("outletdataLocal")) || {};
  } catch (err) {
    outletData = {};
  }

  // Extract first outlet safely
  const outletInfo = outletData?.data?.[0] || {};

  // Convert to numbers for comparison
  const tableNo = Number(localStorage.getItem("QRTableNo")) || 0;
  const guestHouseId = Number(localStorage.getItem("guestHouseId")) || 0;

  // Determine instructions
  let instructions = [];
  if (tableNo === 0 && guestHouseId === 0) {
    instructions = [
      "1. Select the items you want from the menu.",
      "2. If you are already logged in, click the 'Order' button. You will be taken to the cart page, where you can review your order details. Select whether it's Takeaway or Delivery, choose your address, click 'Confirm', and then click 'Place Order'.",
      "3. If you are not logged in, you will be redirected to the login page. Click 'Sign In' if you already have an account, or register a new account. After logging in or registering, you will be automatically taken to the cart page with your previously selected items. Select your address, click 'Confirm', and then click 'Place Order'."
    ];
  } else if (tableNo > 0 && guestHouseId === 0) {
    instructions = [
      `1. You are at table number ${tableNo}.`,
      "2. Scan the QR code to view the menu for your table.",
      "3. Select items and place your order directly from the menu page."
    ];
  } else if (tableNo === 0 && guestHouseId > 0) {
    instructions = [
      `1. You are in guest house room ID ${guestHouseId}.`,
      "2. Scan the QR code to view the room service menu.",
      "3. Select items and confirm to get them delivered to your room."
    ];
  }

  // Safe links
  const googleReviewUrl = outletInfo.gglReviewUrl || "#";
  const instagramUrl = outletInfo.instagramUrl || "#";

  return (
    <>
      <nav className="navbar navbar-light shadow-sm bg-body rounded">
        <div className="container-fluid p-0">
          <div className="row w-100 d-flex justify-content-around align-items-center">

            {/* Home */}
            <div className="col-2 d-flex flex-column align-items-center">
              <NavLink className="nav-link mb-0 d-flex flex-column align-items-center" to="/">
                <img width="22" height="22" src="https://img.icons8.com/?size=100&id=idja0q6oFAQN&format=png&color=000000" alt="Home" />
                <span style={{ fontSize: "10px", color: "black", marginTop: "-1px" }}>Home</span>
              </NavLink>
            </div>

            {/* Review */}
            <div className="col-2 d-flex flex-column align-items-center">
              <a className="nav-link mb-0 d-flex flex-column align-items-center" href={googleReviewUrl} target="_blank" rel="noopener noreferrer">
                <img width="22" height="22" src="https://img.icons8.com/fluency/48/google-logo.png" alt="Google Review" />
                <span style={{ fontSize: "10px", color: "black", marginTop: "-1px" }}>Review</span>
              </a>
            </div>

            {/* QR Instructions */}
            <div className="col-2 d-flex flex-column align-items-center">
              <button
                className="btn p-0 d-flex flex-column align-items-center"
                onClick={() => setShowModal(true)}
                style={{ background: "none", border: "none" }}
              >
                <img
                  width="22"
                  height="22"
                  src="https://img.icons8.com/?size=100&id=GZCw4sVj7YyK&format=png&color=000000"
                  alt="QR Instructions"
                />
                <span style={{ fontSize: "10px", color: "black", marginTop: "-1px", whiteSpace: "nowrap" }}>
                  ? Use
                </span>
              </button>
            </div>

            {/* Instagram */}
            <div className="col-2 d-flex flex-column align-items-center">
              <a className="nav-link mb-0 d-flex flex-column align-items-center" href={instagramUrl} target="_blank" rel="noopener noreferrer">
                <img width="22" height="22" src="https://img.icons8.com/?size=100&id=Xy10Jcu1L2Su&format=png&color=000000" alt="Instagram" />
                <span style={{ fontSize: "10px", color: "black", marginTop: "-1px" }}>Instagram</span>
              </a>
            </div>

            {/* LogIn */}
            <div className="col-2 d-flex flex-column align-items-center">
              <NavLink
                className="nav-link mb-0 d-flex flex-column align-items-center"
                to="/Login"
                onClick={() => localStorage.setItem("backPaath", "/")}
              >
                <img
                  width="22"
                  height="22"
                  src="https://img.icons8.com/?size=100&id=48179&format=png&color=000000"
                  alt="Login"
                />
                <span style={{ fontSize: "10px", color: "black", marginTop: "-1px" }}>LogIn</span>
              </NavLink>

            </div>

            {/* MyOrders */}
            <div className="col-2 d-flex flex-column align-items-center">
              <NavLink className="nav-link mb-0 d-flex flex-column align-items-center" to="/MyOrders">
                <img width="22" height="22" src="https://img.icons8.com/?size=100&id=83967&format=png&color=000000" alt="MyOrders" />
                <span style={{ fontSize: "10px", color: "black", marginTop: "-1px" }}>MyOrders</span>
              </NavLink>
            </div>

          </div>
        </div>
      </nav>

      {/* QR Instructions Modal */}
      {showModal && (
        <div className="modal fade show" style={{ display: "block" }} tabIndex="-1">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">

              <div className="modal-header">
                <h5 className="modal-title">How to Use QR Code</h5>
                <button type="button" className="btn-close" onClick={() => setShowModal(false)}></button>
              </div>

              <div className="modal-body">
                {instructions.map((step, index) => (
                  <p key={index}>{step}</p>
                ))}
              </div>

              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>Close</button>
              </div>

            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Footer;
